<template>
	<div class="settings">
		<v-stepper v-model="stepC" non-linear>
			<v-stepper-header class="companies-stepper">
				<v-stepper-step step="1" editable :complete="step > 1">General</v-stepper-step>
				<!-- <v-divider></v-divider> -->
				<!-- <v-divider></v-divider> -->
				<v-stepper-step step="2" editable :complete="step > 2">Misceláneos 1</v-stepper-step>
				<!-- <v-divider></v-divider> -->
				<v-stepper-step step="3" editable :complete="step > 3">Misceláneos 2</v-stepper-step>
				<!-- <v-divider></v-divider> -->
			</v-stepper-header>
			<v-stepper-items class="companies-content">
				<v-stepper-content step="1" v-if="step === 1">
					<accounting-parametrization-general :rows="rows" @save="$emit('save-general-data', $event)" />
				</v-stepper-content>
			<!--	<v-stepper-content step="2" v-if="step === 2">
					<accounting-parametrization-seating :rows="rows" @save="$emit('save-seats', $event)" />
				</v-stepper-content> -->
				<v-stepper-content step="2" v-if="step === 2">
					<accounting-parametrization-misc-one :rows="rows" @changeStep="$emit('changeStep', $event)" @save="$emit('save-misc-one', $event)" />
				</v-stepper-content>
				<v-stepper-content step="3" v-if="step === 3">
					<accounting-parametrization-misc-two :rows="rows" @get-Data="setData" @edit-Data="$emit('edit-Data', $event)" @save-Data="$emit('save-Data', $event)"/>
				</v-stepper-content>
			</v-stepper-items>
		</v-stepper>
	</div>
</template>

<script>
	import accountingParametrizationGeneral from '@/components/accounting-parametrizations/accounting-parametrization-general';
	import accountingParametrizationMiscOne from '@/components/accounting-parametrizations/accounting-parametrization-misc-one';
	import accountingParametrizationSeating from '@/components/accounting-parametrizations/accounting-parametrization-seating';
	import accountingParametrizationMiscTwo from '@/components/accounting-parametrizations/accounting-parametrization-misc-two';

	function active(value) {
		this.$emit('on-active-change', value);
	}
	function setData(value) {
		this.$emit('set-Data', value);
	}
	function isActive(tab) {
		return Number(this.active) === tab;
	}

	function step(newVal) {
		this.stepC = newVal;
	}

	function stepC(newValue) {
		this.$emit('chage-ste', newValue);
	}

	function data() {
		return {
			active: 0,
			stepC: null,
		};
	}

	export default {
		name: 'accounting-parametrization-tab',
		components: {
			accountingParametrizationGeneral,
			accountingParametrizationMiscOne,
			accountingParametrizationSeating,
			accountingParametrizationMiscTwo,
		},
		data,
		methods: {
			isActive,
			setData,
		},
		props: {
			disabled: {
				default: false,
				type: Boolean,
			},
			rows: {
				default: () => [],
				type: Array,
			},
			step: {
				default: 1,
				type: Number,
			},
		},
		watch: {
			active,
			step,
			stepC,
		},
	};
</script>
<style lang="scss" scoped>
	.tab-accounting {
		padding-bottom: 70px;
	}
	.companies-stepper {
		background-color: #f5f5f5;
		border-bottom: 3px solid #e4e4e4;
		border-top: 3px solid #e4e4e4;
		justify-content: center !important;
		padding: 0 25px;

		@media (min-width: 1300px) {
			padding: 0 158px;
		}
	}
	.companies-content {
		background-color: color(white-content);

		.companies-btn {
			display: flex;
			justify-content: center;
			margin-top: 20px;
		}

		.card {
			box-shadow: 0 0 0 0 ;
		}

		h2 {
			color: map-get($colors, color-input);
			font-family: map-get($fonts, open-semibold);
			font-size: map-get($sizes, large);
		}

		h3 {
			color: map-get($colors, paginationText);
			font-family: map-get($fonts, open-semibold);
			font-size: map-get($sizes, medium18);
			font-weight: normal;
		}
	}
	.settings {
	margin: 0px auto;

	.stepper {
		box-shadow: 0 0 0 0;

		&__header {
			box-shadow: 0 0 0 0;
		}

		&__content {
			padding: 58px 30px 16px;
			max-width: 1150px;
    		margin: 0 auto;
		}
	}

	.stepper__label {
		color: #9ca6b0;
		font-size: 12px !important;
		font-weight: 600;
	}

	.stepper__step--active {
		background-color: #e4e4e4;
		color: #4a4a4a !important;
	}

	.stepper__step {
		padding: 21px 13px !important;
	}

	.stepper:not(.stepper--vertical) .stepper__label {
		@media (max-width: 1200px) {
			display: none !important;
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/components/accounting-parametrizations/accounting-parametrization-tab.vue